module.exports = __webpack_public_path__ + "static/media/chess.f928c6a3.jpg";